import React from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import ExploreResultLocations from "../component/ExploreResultLocations";
import SellBanner from "../component/SellBanner";
import AboutBox from "../component/AboutBox";
import FAQ from "../component/FAQ";
import ConnectAgentCTA from "../component/ConnectAgentCTA";
import SellWithAgent from "../component/SellWithAgent";
import FindYourOwnAgent from "../component/FindYourOwnAgent";
function Sell() {
  return (
    <>
      <div className="main about-us-page">
        <Header />
        <SellBanner />
        <SellWithAgent />
        <FindYourOwnAgent /> 
        <FAQ />
        <ConnectAgentCTA />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}
export default Sell;
